import React from "react";
import "./journey.css";
import { BiCheck } from "react-icons/bi";

const highlights = [
  "Delivered 6 commercial client projects end to end",
  "Managed a 5-member multidisciplinary team",
  "Built games with Unity, MonoGame, and WinForms",
  "Mentored 2 Unity interns",
  "Led Agile production and sprint planning",
  "Partnered with clients from concept through delivery",
];

const leadership = [
  "Lead globally distributed teams across multiple countries",
  "Run weekly sprint planning and Scrum ceremonies",
  "Coordinate engineering, art, design, QA, and marketing",
  "Translate client vision into production roadmaps",
  "Mentor junior Unity developers",
  "Balance hands-on technical work with production management",
];

const List = ({ items }) => (
  <ul className="journey__list">
    {items.map((item) => (
      <li key={item}>
        <span className="point-icon"><BiCheck /></span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const Journey = () => {
  return (
    <section id="experience">
      <h5>Where I've Led</h5>
      <h2>Experience &amp; Leadership</h2>

      <div className="container journey__container">
        <article className="journey__panel">
          <div className="journey__role">
            <div>
              <h3>Lead Game Developer · Technical Producer</h3>
              <p className="journey__company">Webanix Solutions</p>
            </div>
            <span className="journey__chip">Current Role</span>
          </div>
          <p className="journey__summary">
            Leading the development and production of commercial games — managing
            engineering teams, coordinating stakeholders, and delivering
            interactive experiences for clients across gaming, education, and
            enterprise.
          </p>
          <List items={highlights} />
        </article>

        <article className="journey__panel">
          <div className="journey__role">
            <div>
              <h3>How I Lead</h3>
              <p className="journey__company">People · Process · Production</p>
            </div>
          </div>
          <List items={leadership} />
        </article>
      </div>

      <blockquote className="container philosophy">
        <span className="philosophy__mark">“</span>
        <p>
          Great games aren't built by individuals — they're built by aligned
          teams with a clear vision. A producer's job is to remove obstacles,
          empower developers, and create the environment where creative ideas
          become exceptional player experiences.
        </p>
        <cite>— My production philosophy</cite>
      </blockquote>
    </section>
  );
};

export default Journey;
